<script>
    import Aws from '@/services/Aws';
    import { required, integer, minValue} from "vuelidate/lib/validators";
    import validationMessages from '@/components/validations'
    import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";


    export default {
        components:{
            flatPickr,
            validationMessages
        },
        props: ['scheduledActionData', 'applicationsData'],
        watch: {
            scheduledActionData: function(newVal) {
                if(newVal){
                    this.loadScheduledAction(newVal);
                }
            },
            applicationsData: function(newVal) {
                if(newVal){
                    this.applications = newVal;
                }
            }
        },
        data() {
            return {
                csrf_token: localStorage.getItem('csrf_token'),
                submitted: false,
                showModal: false,
                tryingToEdit: false,
                showLoader:false,
                showLoader2:false,
                applications:[],
                scheduledActionId: null,
                application_id:'',
                application_name:'',
                rdsCluster:'',
                targetgroup:'',
                autoScalingGroups:[],
                autoScalingGroup:[],
                action:'',
                MinSize: 0,
                MaxSize: 0,
                start_at: '',
                DBInstances: 1,
                DBInstancesOriginal: 1,
                MinSizeOriginal: 0,
                MaxSizeOriginal: 0,
                scheduledMinSize: null,
                scheduledMaxSize: null,
                scheduledDBInstances: null,
                readerCount:[],
                classTypes:[],
                classType:'',
                datetimeconfig: {
                    enableTime: true,
                    time_24hr: true,
                    dateFormat: "Y-m-d H:i",
                    minDate: new Date(),
                    minuteIncrement: 10
                },
            };
        },
        validations() {
            if (this.action === 'update_auto_scaling_group') {
                return {
                    start_at:{
                        required
                    },
                    MinSize: {
                        required,
                        integer,
                        minValue: minValue(1),
                        valid: function() {
                            return this.minSizeMaxCheck()
                        }
                    },
                    MaxSize: {
                        required,
                        integer,
                        minValue: minValue(1),
                        valid: function() {
                            return this.minSizeMaxCheck()
                        }
                    }
                };
            } if(this.action === 'read_db_instance') {
                return {
                    start_at:{
                        required
                    },
                    DBInstances:{
                        required,
                        minValue: minValue(1),
                    },
                    classType:{
                        required
                    }
                };
            } else {
                return {
                    start_at:{
                        required
                    }
                };
            }
        },
        methods: {

            minSizeMaxCheck () {
                return this.MinSize <= this.MaxSize || !this.MinSize || !this.MaxSize;
            },

            parseInput(input) {
                if (!input) {
                    return {};
                }

                if (typeof input === 'object') {
                    return input;
                }

                try {
                    return JSON.parse(input);
                } catch (error) {
                    return {};
                }
            },

            async getAutoScalingGroups() {
                try {
                    const response = await Aws.getAutoScalingGroups();
                    this.autoScalingGroups = response.data.data;
                } catch (error) {
                    this.error = error.response.data.error ? error.response.data.error : "";
                }
            },

            loadScheduledAction(scheduledAction) {
                const input = this.parseInput(scheduledAction.input);

                this.scheduledActionId = scheduledAction.id;
                this.application_id = scheduledAction.application_id;
                this.application_name = scheduledAction.application_name;
                this.action = scheduledAction.action_name;
                this.start_at = scheduledAction.start_at ? scheduledAction.start_at.substring(0, 16) : '';

                if (this.action === 'update_auto_scaling_group') {
                    this.autoScalingGroup = {
                        AutoScalingGroupName: input.AutoScalingGroupName
                    };
                    this.MinSize = input.MinSize;
                    this.MaxSize = input.MaxSize;
                    this.scheduledMinSize = input.MinSize;
                    this.scheduledMaxSize = input.MaxSize;
                    this.targetgroup = this.getTargetGroup(this.application_id);
                    const liveAutoScalingGroup = this.getAutoScalingGroupByTargetGroup(this.targetgroup);
                    this.MinSizeOriginal = liveAutoScalingGroup ? liveAutoScalingGroup.MinSize : input.MinSize;
                    this.MaxSizeOriginal = liveAutoScalingGroup ? liveAutoScalingGroup.MaxSize : input.MaxSize;
                }

                if (this.action === 'read_db_instance') {
                    this.rdsCluster = input.DBClusterIdentifier;
                    this.classType = input.classType;
                    this.DBInstances = input.DBInstances;
                    this.scheduledDBInstances = input.DBInstances;
                    this.getRDSInstances();
                }
            },

            async editScheduledAction(){
                this.tryingToEdit = true;
                this.submitted = true;
                this.$v.$touch();

                if (this.$v.$invalid) {
                    this.tryingToEdit = false;
                    return;
                }

                try {
                    let params = {
                        start_at: this.start_at,
                        csrf_token: this.csrf_token
                    };

                    if (this.hasSizingChanges()) {
                        const scalingAction = this.getScalingAction();
                        if (scalingAction) {
                            params.scaling_action = scalingAction;
                        }
                    }

                    if(this.action == 'update_auto_scaling_group'){
                        params.input = {
                            AutoScalingGroupName: this.autoScalingGroup.AutoScalingGroupName,
                            MinSize: this.MinSize,
                            MaxSize: this.MaxSize,
                        };
                    }
                    if(this.action == 'read_db_instance'){
                        params.input = {
                            DBInstances: this.DBInstances,
                            DBClusterIdentifier: this.rdsCluster,
                            classType: this.classType
                        };
                    }

                    await Aws.editScheduledAction(this.scheduledActionId, params).then(() => {
                        this.successmsg("Scheduled action successfully updated");
                        this.closeModal();
                    }).catch(error => {
                        this.error = error.response.data.error ? error.response.data.error : "";
                        this.failedmsg(this.error);
                    }).finally(() => {
                        this.refreshData();
                        this.tryingToEdit = false;
                    });
                } catch (error) {
                    this.error = error.response.data.error ? error.response.data.error : "";
                    this.failedmsg(this.error);
                    this.tryingToEdit = false;
                }
            },

            getTargetGroup(applicationId) {
                const app = this.applications.find(app => app.id === applicationId);
                if (app) {
                    const targetGroupResource = app.resources.find(resource => resource.resource_type === "targetgroups");
                    return targetGroupResource ? targetGroupResource.resource_id : null;
                }
                return null;
            },

            getAutoScalingGroupByTargetGroup(targetGroupArn) {
                if (!targetGroupArn) {
                    return null;
                }
                return this.autoScalingGroups.find(group => group.TargetGroupARNs.includes(targetGroupArn)) || null;
            },

            getRDSInstances() {
                this.showLoader2 = true;
                Aws.getRDSInstances({
                    DBClusterIdentifier: this.rdsCluster
                })
                    .then((response) => {
                        if (response.data) {
                            let DBinstances = response.data.data;
                            const groupedInstances = DBinstances.reduce((acc, instance) => {
                                const clusterId = instance.DBClusterIdentifier || 'No Cluster';
                                if (!acc[clusterId]) {
                                    acc[clusterId] = [];
                                }
                                acc[clusterId].push(instance);
                                return acc;
                            }, {});

                            this.readerCount = Object.keys(groupedInstances).reduce((countAcc, clusterId) => {
                                countAcc[clusterId] = groupedInstances[clusterId].filter(
                                    instance => instance.InstanceRole === 'reader' && instance.DBInstanceStatus != 'deleting'
                                ).length;
                                return countAcc;
                            }, {});

                            this.DBInstancesOriginal = this.readerCount[this.rdsCluster] !== undefined
                                ? this.readerCount[this.rdsCluster]
                                : this.DBInstances;
                        }
                    })
                    .catch((error) => {
                        this.error = error.response && error.response.data && error.response.data.error
                            ? error.response.data.error
                            : "An error occurred";
                    }).finally(() => {
                        this.showLoader2 = false;
                    });
            },

            getRDSClassTypes(){
                Aws.getRDSClassTypes().then((response) => {
                    if(response.data.data){
                        this.classTypes = response.data.data.map(c => c.class_name);
                    }
                }).catch((error) => {
                    this.error = error.response.data.error
                        ? error.response.data.error
                        : "";
                });
            },

            refreshData() {
                this.$emit('onRefresh');
            },

            closeModal() {
                this.showModal = false;
            },

            initialData(){
                this.getAutoScalingGroups();
                this.getRDSClassTypes();
                if (this.scheduledActionData) {
                    this.loadScheduledAction(this.scheduledActionData);
                }
            },

            resetForm(){
                this.scheduledActionId = null;
                this.start_at = '';
                this.application_id = '';
                this.application_name = '';
                this.action = '';
                this.MinSize = 0;
                this.MinSizeOriginal = 0;
                this.MaxSize = 0;
                this.MaxSizeOriginal = 0;
                this.DBInstances = 1;
                this.DBInstancesOriginal = 1;
                this.scheduledMinSize = null;
                this.scheduledMaxSize = null;
                this.scheduledDBInstances = null;
                this.submitted = false;
                this.tryingToEdit = false;
            },

            hasSizingChanges() {
                if (this.action === 'update_auto_scaling_group') {
                    return this.MinSize !== this.scheduledMinSize || this.MaxSize !== this.scheduledMaxSize;
                }

                if (this.action === 'read_db_instance') {
                    return this.DBInstances !== this.scheduledDBInstances;
                }

                return false;
            },

            getScalingAction(){
                if(this.action == 'read_db_instance'){
                    if(this.DBInstancesOriginal > this.DBInstances){
                        return 'decrease';
                    }
                    if(this.DBInstancesOriginal < this.DBInstances){
                        return 'increase';
                    }
                }

                if(this.action == 'update_auto_scaling_group'){
                    if(this.MinSizeOriginal > this.MinSize){
                        return 'decrease';
                    }
                    if(this.MinSizeOriginal < this.MinSize){
                        return 'increase';
                    }
                }

                return null;
            }
        }
    };
</script>

<template>
    <b-modal @shown="initialData" v-model="showModal" id="edit_ScheduledAction" title="Edit Scheduled Action" title-class="font-18" @hidden="resetForm" centered>
        <form @submit.prevent="editScheduledAction" v-if="!showLoader">

            <div class="row">
                <div class="col-sm-12">
                    <label class="form-label mb-2">Start At</label>
                    <flat-pickr
                            v-model="start_at"
                            :config="datetimeconfig"
                            class="form-control mb-2"
                            :class="{ 'is-invalid': submitted && $v.start_at.$error }"
                            name="published"
                    />
                    <validationMessages v-if="submitted" :fieldName="'Start At'" :validationName="$v.start_at"></validationMessages>
                </div>

                <div class="col-sm-12">
                    <b-form-group label="Application">
                        <input type="text" class="form-control" :value="application_name" disabled />
                    </b-form-group>
                </div>

                <div class="col-sm-12">
                    <b-form-group label="Action" class="mb-3">
                        <input type="text" class="form-control" disabled
                               :value="action == 'update_auto_scaling_group' ? 'Application Servers' : action == 'read_db_instance' ? 'Database Reader Instances' : action"
                        />
                    </b-form-group>
                </div>
            </div>

            <div class="row" v-if="action == 'update_auto_scaling_group'">
                <div class="col-sm-12">
                    <h5 class="text-center">{{autoScalingGroup.AutoScalingGroupName}}</h5>
                </div>
                <div class="col-sm-12 col-md-12">
                    <div class="form-group">
                        <label for="editMinSize">Min Size:</label>
                        <input type="number" id="editMinSize"
                               class="form-control"
                               v-model.number="MinSize"
                               min="1" max="10"
                               :class="{
                                  'is-invalid': submitted && $v.MinSize.$error,
                                }"
                        />
                        <validationMessages v-if="submitted" :fieldName="'Min Size'" :validationName="$v.MinSize"></validationMessages>
                    </div>
                </div>

                <div class="col-sm-12 col-md-12">
                    <div class="form-group">
                        <label for="editMaxSize">Max Size:</label>
                        <input type="number" id="editMaxSize"
                               class="form-control"
                               v-model.number="MaxSize"
                               min="1" max="100"
                               :class="{
                                  'is-invalid': submitted && $v.MaxSize.$error,
                                }"
                        />
                        <validationMessages v-if="submitted" :fieldName="'Max Size'" :validationName="$v.MaxSize"></validationMessages>
                    </div>
                </div>
            </div>

            <div class="row" v-if="action == 'read_db_instance'">
                <div class="col-sm-12">
                    <h5 class="text-center">Cluster Name: {{rdsCluster}} </h5>
                </div>

                <div class="col-sm-12 col-md-12" v-if="!showLoader2">
                    <label class="control-label form-label">Choose Instance Class Type</label>
                    <b-form-select
                            class="form-control"
                            aria-describedby="instanceClassType"
                            v-model="classType"
                            :class="{
                      'is-invalid': submitted && $v.classType.$error,
                    }"
                    >
                        <option v-for="type in classTypes" :key="type" :value="type">
                            {{ type }}
                        </option>
                    </b-form-select>
                    <validationMessages v-if="submitted" :fieldName="'Class Type'" :validationName="$v.classType"></validationMessages>
                </div>

                <div class="col-sm-12 col-md-12" v-if="!showLoader2">
                    <div class="form-group">
                        <label for="editDbInstances">Total Number of Read DB Instances :</label>
                        <input type="number" id="editDbInstances"
                               class="form-control"
                               v-model.number="DBInstances"
                               min="1" max="10"
                               :class="{
                                  'is-invalid': submitted && $v.DBInstances.$error,
                                }"
                        />
                        <validationMessages v-if="submitted" :fieldName="'DB Instances'" :validationName="$v.DBInstances"></validationMessages>
                    </div>
                </div>
                <div class="card-body d-flex align-items-center justify-content-center" v-else>
                    <b-spinner large></b-spinner>
                </div>
            </div>

        </form>
        <div class="card-body d-flex align-items-center justify-content-center" v-else>
            <b-spinner large></b-spinner>
        </div>
        <template v-slot:modal-footer>
            <b-button variant="light" @click="closeModal">Close</b-button>
            <b-button variant="primary" @click="editScheduledAction" :disabled="tryingToEdit || showLoader">
                <b-spinner v-show="tryingToEdit" small></b-spinner>
                Save</b-button>
        </template>
    </b-modal>
</template>
